import React, { FC } from "react";

/**
 * Static escalation contacts shown on the home screen so users know who to
 * contact when something needs escalating. Display only - deliberately no API,
 * no editing and no interactivity.
 */
const ESCALATION_LEVELS = [
  {
    level: "Level 1",
    name: "Nikhil Bhosale",
    email: "nikhil.bhosale@hdfc.bank.in",
  },
  {
    level: "Level 2",
    name: "Abhishek Mathur",
    email: "abhishek.mathur4@hdfc.bank.in",
  },
  {
    level: "Level 3",
    name: "Abhilasha Mathur",
    email: "abhilasha.mathur@hdfc.bank.in",
  },
];

export const EscalationMatrix: FC = () => (
  <div className='escalation-matrix'>
    <span className='escalation-matrix__title'>Escalation Matrix</span>
    <div className='escalation-matrix__levels'>
      {ESCALATION_LEVELS.map((item) => (
        <div className='escalation-matrix__row' key={item.level}>
          <span className='escalation-matrix__level'>
            {item.level}: {item.name}
          </span>
          <a className='escalation-matrix__email' href={`mailto:${item.email}`}>
            {item.email}
          </a>
        </div>
      ))}
    </div>
  </div>
);
